<template>
  <div>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <div>
      <div
        v-if="!isSeller"
        class="has-background-white-ter is-border-bottom is-padding">
        <div class="field">
          <div class="control">
            <input
              id="selfRdv"
              type="checkbox"
              name="selfRdv"
              v-model="selfRdv"
              class="switch is-success is-rounded">
            <label for="selfRdv">Ce rendez-vous est pour moi</label>
          </div>
        </div>
        <div
          v-if="!selfRdv && !isSeller && userCount > 1"
          class="field">
          <r-label
            :is-required="false"
            :label="'Utilisateur'"
            :value="user"
            :for-id="'user'"></r-label>
          <div class="control">
            <multiselect
              v-model="user"
              :placeholder="''"
              id="user"
              :custom-label="val => limitText(`${val.last_name} ${val.first_name}`)"
              :options="users"
              name="user"
              v-validate="'required'"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              class="multiselect--option-ico"
              @search-change="getUsers">
              <span slot="noResult">Oups! Aucune société trouvée.</span>
              <span slot="noOptions">La liste est vide</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Sélectionnez ou saisissez un utilisateur</span>
            </multiselect>
            <p
              v-if="errors.has('user')"
              class="help is-danger">
              {{ errors.first('user') }}
            </p>
          </div>
        </div>
        <div
          v-else-if="!selfRdv && !isSeller && userCount <= 1"
          class="field">
          Aucun autre utilisateur
        </div>
      </div>

      <div class="has-background-light is-padding">
        <div class="field">
          <r-label
            :is-required="false"
            :label="'Type de rendez-vous'"></r-label>
          <div class="field is-grouped is-grouped-multiline">
            <div class="control is-expanded">
              <input
                id="R0-quick"
                v-model="rdv.rdv_type"
                value="R0"
                name="typeRdv"
                class="vadCheckradiocase is-primary is-fullwidth"
                type="radio">
              <label
                class="is-minW70p"
                for="R0-quick">R0</label>
            </div>
            <div class="control is-expanded">
              <input
                id="R1-quick"
                v-model="rdv.rdv_type"
                value="R1"
                name="typeRdv"
                class="vadCheckradiocase is-primary is-fullwidth"
                type="radio">
              <label
                class="is-minW70p"
                for="R1-quick">R1</label>
            </div>
            <div class="control is-expanded">
              <input
                id="R2-quick"
                v-model="rdv.rdv_type"
                value="R2"
                name="typeRdv"
                class="vadCheckradiocase is-primary is-fullwidth"
                type="radio">
              <label
                class="is-minW70p"
                for="R2-quick">R2</label>
            </div>
            <div class="control is-expanded">
              <input
                id="R3-quick"
                v-model="rdv.rdv_type"
                value="R3"
                name="typeRdv"
                class="vadCheckradiocase is-primary is-fullwidth"
                type="radio">
              <label
                class="is-minW70p"
                for="R3-quick">R3</label>
            </div>
          </div>
        </div>
        <div class="field is-margin-top-small">
          <r-label
            :is-required="false"
            :label="'Date du rendez-vous'"
            :for-id="'dateEvent'"></r-label>
          <date-picker
            :id="'dateEvent'"
            :model="date"
            :style-version="2"
            @input="date = $event"
            :field-class="''"
            :input-class="'is-fullwidth'"></date-picker>
        </div>

        <div class="is-margin-top-small">
          <div class="columns">
            <div class="column">
              <r-label
                :is-required="false"
                :label="'Heure début'"
                :for-id="'dateHourStart'"></r-label>
              <date-picker
                :id="'dateHourStart'"
                @input="dateHourStart = $event"
                :model="dateHourStart"
                :field-class="''"
                :is-hour="true"
                :config="configHour"
                :input-class="'is-fullwidth'"
                :style-version="2"
                :icone-main="'fal fa-clock'"></date-picker>
            </div>
            <div class="column">
              <r-label
                :is-required="false"
                :label="'Heure fin'"
                :for-id="'dateHourEnd'"></r-label>
              <date-picker
                :id="'dateHourEnd'"
                @input="dateHourEnd = $event"
                :is-hour="true"
                :model="dateHourEnd"
                :field-class="''"
                :config="configHour"
                :input-class="'is-fullwidth'"
                :style-version="2"
                :icone-main="'fal fa-clock'"></date-picker>
            </div>
          </div>
        </div>
      </div>

      <div
        class="is-border-top is-padding"
        v-if="contact === null">
        <div
          class="field"
          v-if="!formContact">
          <r-label
            :is-required="false"
            :label="'Séléctionner un contact'"
            :value="contact"
            :for-id="'contact'"></r-label>
          <div class="control">
            <multiselect
              v-model="contact"
              :placeholder="''"
              id="contact"
              :options="contacts"
              :searchable="true"
              :custom-label="val => limitText(`${val.last_name} ${val.first_name}`)"
              :close-on-select="true"
              :show-labels="false"
              @search-change="getContracts"
              class="multiselect--option-ico">
              <span slot="noResult">Oups! Aucune contact trouvée.</span>
              <span slot="noOptions">La liste est vide</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Sélectionnez ou saisissez un contact</span>
            </multiselect>
            <!--<p class="help is-danger" v-if="!user">Veuillez sélectionner un utilisateur</p>-->
          </div>
        </div>
        <div class="field">
          <button
            @click="formContact = !formContact"
            class="button is-light is-border is-fullwidth is-rounded">
            <span
              v-if="!formContact"
              class="is-transform-none">Créer un nouveau contact</span>
            <span
              v-else
              class="is-transform-none">Annuler nouveau contact</span>
          </button>
          <div
            id="test"
            v-if="formContact"
            class="is-padding-top">
            <contact-form
              ref="contact_form"
              @submit="checkBeforesubmitContactResponse"
              @send-data="handleData"
              :alertdoubloncheck="alertDoublonCheck"
              :from-quickview="true"></contact-form>
            <div class="is-padding-top">
              <button
                v-if="alertCheck"
                @click="checkSubmitContact"
                class="button is-success is-fullwidth">
                <span v-if="isLoadingContact"><i class="fas fa-spinner fa-spin"></i></span>
                <span v-else>Créer contact</span>
              </button>
              <button
                v-else
                @click="submitContact"
                class="button is-danger is-fullwidth">
                <span v-if="isLoadingContact"><i class="fas fa-spinner fa-spin"></i></span>
                <span v-else>Confirmez l'enregistrement</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="is-border-top is-padding">
        <r-label
          :is-required="false"
          :label="'Contact'"></r-label>
        <div class="columns is-vcentered">
          <div class="column is-narrow">
            <avatar :item="contact"></avatar>
          </div>
          <div class="column">
            <div class="title is-4 is-marginless">
              {{ contact.last_name }} {{ contact.first_name }}
            </div>
            <div
              class=""
              v-if="contact.address">
              {{ contact.address.line1 }} {{ contact.address.code_zip }} {{ contact.address.city }}
            </div>
          </div>
          <div class="column is-narrow">
            <a
              class="button is-circle is-action is-small"
              @click="contact = null">
              <span class="icon is-small"><i class="fal fa-times"></i></span>
            </a>
          </div>
        </div>
      </div>

      <div class="is-border-top is-padding">
        <div
          v-if="contact !== null && contact.address"
          class="field">
          <div class="control">
            <input
              id="event_adress_contact_adress"
              type="checkbox"
              name="event_adress_contact_adress"
              v-model="selectContactAddress"
              class="switch is-success is-medium is-rounded">
            <label for="event_adress_contact_adress"><span class="is-size-5">Rendez-vous à l'adresse du contact</span></label>
          </div>
        </div>
        <address-input
          v-if="!selectContactAddress"
          :source="address"
          :from-quickview="true"
          :placeholder="'indiquer le lieu du rendez-vous'"
          @update="updateAddress">
        </address-input>
      </div>

      <div
        class="is-border-top is-padding"
        v-if="userCount > 1">
        <div class="field">
          <r-label
            :is-required="false"
            :label="'Inviter utilisateur(s)'"
            :value="guests"
            :for-id="'guests'"></r-label>
          <div class="control">
            <multiselect
              v-model="guests"
              :placeholder="''"
              id="guests"
              track-by="pk"
              :options="userListForInvitation"
              :searchable="true"
              :close-on-select="false"
              :show-labels="false"
              :multiple="true"
              data-vv-as="Invite"
              :custom-label="val => limitText(`${val.last_name} ${val.first_name}`)"
              class="multiselect--option-ico">
              <span slot="noResult">Oups! Aucune utilisateur trouvée.</span>
              <span slot="noOptions">La liste est vide</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Sélectionnez ou saisissez un utilisateur</span>
            </multiselect>
            <!--<p class="help is-danger" v-if="!user">Veuillez sélectionner un utilisateur</p>-->
          </div>
        </div>
      </div>

      <div class="is-border-top is-padding has-background-light">
        <div class="field">
          <r-label
            :is-required="false"
            :label="'Ajouter commentaire'"></r-label>
          <div class="control">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="rdv.note"
              :from-quickview="true"
              @change="val => rdv.note = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless has-background-white">
            </wysiwyg-editor>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { cloneDeep } from 'lodash'
const emptyRdv = Object.freeze({
  rdv_type: 'R0',
  address: null,
  guests: [],
  date: null,
  user: null,
  note: null,
  end_date: null,
  contact: null
})
export default {
  name: 'CalendarForm',
  components: {
    ContactForm: () => import('@/components/contacts/ContactForm')
  },
  props: {
    source: {
      type: Object
    },
    previous: {
      type: String,
      default: null
    },
    contactSource: {
      type: Object
    },
    fromCalendarDate: {
      default: null
    }
  },
  data () {
    return {
      fromCreated: true,
      userCount: null,
      contactCount: null,
      fromInit: false,
      isUpdatedRdv: false,
      isLoadingContact: false,
      formContact: false,
      note: null,
      selectContactAddress: false,
      address: null,
      rdv: null,
      loading: false,
      selfRdv: true,
      users: [],
      contacts: [],
      guests: [],
      user: null,
      contact: null,
      date: null,
      dateHourStart: moment().hour(7).minute(0).format('HH:mm'),
      dateHourEnd: moment().hour(8).minute(0).format('HH:mm'),
      alertCheck: true,
      alertDoublonCheck: {},
      configHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        altFormat: 'H:i',
        time_24hr: true
      }
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isManager', 'isSeller']),
    userListForInvitation () {
      let results = cloneDeep(this.users)
      let pkToExclude
      if (this.selfRdv) {
        pkToExclude = this.currentUser.pk
      } else if (this.user) {
        pkToExclude = this.user.pk
      }
      let index = results.findIndex(x => x.pk === pkToExclude)
      if (index >= 0) {
        results.splice(index, 1)
      }
      return results
    }
  },
  watch: {
    selfRdv (v) {
      if (!this.fromInit) {
        this.user = null
      }
    },
    selectContactAddress (v) {
      if (v) {
        this.$set(this.rdv, 'address', this.contact.address)
        this.$set(this, 'address', this.contact.address)
      } else {
        this.$set(this, 'address', null)
        this.$set(this.rdv, 'address', null)
      }
    },
    dateHourStart (v) {
      if (v) {
        let endHour = this.dateHourEnd
        endHour = endHour.split(':')
        let startHour = v
        startHour = startHour.split(':')
        if (Number(endHour[0]) < Number(startHour[0])) {
          endHour[0] = Number(startHour[0]) + 1
          this.dateHourEnd = endHour[0] + ':' + endHour[1]
          this.dateHourEnd = this.dateHourEnd.toString()
        }
      }
    },
    dateHourEnd (v) {
      if (v) {
        let endHour = v
        endHour = endHour.split(':')
        let startHour = this.dateHourStart
        startHour = startHour.split(':')
        if (Number(endHour[0]) < Number(startHour[0])) {
          startHour[0] = Number(endHour[0]) - 1
          this.dateHourStart = startHour[0] + ':' + startHour[1]
          this.dateHourStart = this.dateHourStart.toString()
        }
      }
    }
  },
  async created () {
    if (this.source && !this.previous) {
      this.fromInit = true
      await this.initRdv()
      this.fromInit = false
    } else {
      this.rdv = Object.assign({}, emptyRdv)
      if (this.contactSource) {
        this.contact = this.contactSource
      }
      if (this.fromCalendarDate) { // if we are comming from CalendarDay's or CalendarMonthItem's click on a specific day, prefill this day in the form
        this.date = this.fromCalendarDate
      } else {
        this.date = moment().add(1, 'day').hours(8).startOf('hour').toDate()
      }
      if (this.previous) {
        this.fromInit = true
        await this.initRdvPrevious()
        this.fromInit = false
      }
    }
    await this.getUsers()
    this.fromCreated = false
    this.getContracts()
  },
  methods: {
    initRdvPrevious () {
      if (this.source.status === 'successful') {
        let type = Number(this.source.rdv_type.split('')[1]) + 1
        if (type < 4) this.rdv.rdv_type = `R${type}`
      }
      if (this.source.status === 'deferred') {
        if (this.source.note) {
          this.rdv.note = this.source.note
        }
        if (this.source.guests.length) {
          this.$set(this, 'guests', this.source.guests)
        }
      }
      if (this.source.address) {
        this.$set(this, 'address', this.source.address)
      }
      if (this.source.user.pk !== this.currentUser.pk) {
        this.selfRdv = false
        this.user = this.source.user
      }
      this.contact = this.source.contact
    },
    initRdv () {
      this.isUpdatedRdv = true
      this.rdv = Object.assign({}, this.source)
      this.date = moment.utc(this.rdv.date).toDate()
      let endDate = moment.utc(this.rdv.end_date).toDate()
      this.dateHourStart = moment(this.date).format('HH:mm')
      this.dateHourEnd = moment(endDate).format('HH:mm')
      if (this.rdv.address) {
        this.$set(this, 'address', this.rdv.address)
      }
      if (this.rdv.guests.length) {
        this.$set(this, 'guests', this.rdv.guests)
      }
      if (this.rdv.user.pk !== this.currentUser.pk) {
        this.selfRdv = false
        this.user = this.rdv.user
      }
      this.contact = this.rdv.contact
    },
    async submitRdv () {
      this.$store.commit('setQuickviewLoading', true)
      let endHour = document.querySelector('#dateHourEnd div .flatpickr-input').value
      endHour = endHour.split(':')

      let startHour = document.querySelector('#dateHourStart div .flatpickr-input').value
      startHour = startHour.split(':')

      if (Number(endHour[0]) < Number(startHour[0])) {
        this.$toasted.global.danger('Veuillez renseigner une heure de fin inférieur a l\'heure de début')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      if (!this.selfRdv && !this.user) {
        this.$toasted.global.danger('Veuillez renseigner l\'utilisateur associé au rendez-vous.')
        this.$store.commit('setQuickviewLoading', false)
        return
      }
      if (!this.contact) {
        this.$toasted.global.danger('Veuillez renseigner le contact associé au rendez-vous.')
        this.$store.commit('setQuickviewLoading', false)
        return
      }
      let rdv = Object.assign({}, this.rdv)
      if (!this.selfRdv) {
        rdv.user = this.user.pk
      } else {
        rdv.user = this.currentUser.pk
      }
      rdv.contact = this.contact.pk
      if (this.guests.length) {
        rdv.guests = this.guests.map(x => x.pk)
      } else {
        rdv.guests = []
      }
      if (this.previous) {
        rdv.previous_rdv = this.previous
      }
      let newDate = moment(this.date).set({ 'hour': startHour[0], 'minute': startHour[1] })
      this.date = newDate._d
      let newDateEnd = moment(this.date).set({ 'hour': endHour[0], 'minute': endHour[1] })
      rdv.end_date = newDateEnd._d
      rdv.end_date = moment.utc(rdv.end_date).toISOString()
      rdv.date = moment.utc(this.date).toISOString()

      if (!this.selectContactAddress && this.address) {
        rdv.address = Object.assign({}, this.address)
      }
      try {
        let request
        let date
        if (this.isUpdatedRdv) {
          request = await this.$api.put(this.$resources.RDV, rdv.pk, rdv)
          date = moment(request.data.date)
          let eventPk = rdv.pk
          let newDate = moment(date).format('DD/MM/YYYY')
          let sourceDate = moment(this.source.date).format('DD/MM/YYYY')
          this.$store.commit('removeCalendarEvent', { eventPk, sourceDate, type: 'rdvs' })
          this.$store.commit('addCalendarEvent', { event: request.data, key: newDate, type: 'rdvs' })
        } else {
          request = await this.$api.post(this.$resources.RDV, rdv)
          date = moment(request.data.date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: request.data, key: key, type: 'rdvs' })
        }
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        let day = moment(date).format('DD')
        let month = moment(date).format('MM')
        let year = moment(date).format('YYYY')
        if (this.$route.meta.routeType === 'Contact') {
          this.$router.replace({ name: 'ContactRdvs' }).catch(() => {})
        } else {
          this.$router.push({ name: 'CalendarDay', params: { year, month, day, panel: 'rdvs' } })
        }
        if (this.isUpdatedRdv) {
          this.$toasted.global.success('Rendez-vous modifié.')
        } else {
          this.$toasted.global.success('Rendez-vous créé.')
        }
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      } finally {
        this.$store.commit('setQuickviewLoading', false)
      }
    },
    handleData (data) {
      this.alertDoublonCheck = {}
      this.alertCheck = data
    },
    async checkBeforesubmitContactResponse (elem) {
      let contact = Object.assign({}, elem)
      if (!contact.first_name) {
        this.$toasted.global.danger('Veuillez renseignez un prénom')
        return
      }
      if (!contact.last_name) {
        this.$toasted.global.danger('Veuillez renseignez un nom')
        return
      }
      contact.user = this.currentUser.pk
      let payload = {
        contact: this.$cleanPayload(contact),
        user: this.currentUser.pk
      }
      let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
      if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
        this.alertCheck = false
        this.alertDoublonCheck = data
      } else {
        this.submitContactResponse(elem)
      }
    },
    async submitContactResponse (elem) {
      this.isLoadingContact = true
      let contact = Object.assign({}, elem)
      contact.user = this.currentUser.pk
      try {
        let { data } = await this.$api.post(this.$resources.CONTACT, this.$cleanPayload(contact))
        data = data.json_data
        this.contact = data
        this.$toasted.global.success('Contact ajouté')
        this.isLoadingContact = false
        this.formContact = false
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
        this.isLoadingContact = false
      }
    },
    checkSubmitContact () {
      var element = document.getElementById('test')
      element.scrollIntoView()
      this.$refs.contact_form.submit()
    },
    submitContact () {
      this.submitContactResponse(this.$refs.contact_form.contact)
    },
    updateAddress (address) {
      this.$set(this, 'address', address)
    },
    limitText (text) {
      if (text.length > 20) {
        return text.substring(0, 20) + '...'
      } else return text
    },
    async getUsers (query = null) {
      let params = {
        searchable_name: query
      }
      try {
        let { data } = await this.$api.get(this.$resources.USER, params)
        if (this.fromCreated) {
          this.userCount = data.count
        }
        this.users = data.items
      } catch (err) {
        console.log(err)
      }
    },
    async getContracts (query = null) {
      let params = {
        searchable_name: query
      }
      try {
        let { data } = await this.$api.get(this.$resources.CONTACT, params)
        this.contacts = data.items
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
